import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryCustomerOrder = {
  async customerOrder(parent, args, context, info) {
    const { orderNumber } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ORDERS,
      operation: Operations.READ,
    })

    const graphiQLQueryObject = [
      {
        method: "findOrder",
        variables: { orderNumber },
        fields: [
          "orderNumber",
          "customerNumber",
          "paymentMethod",
          "orderType",
          "orderDate",
          "admNumber",
          "totalAmount",
          "branchNumber",
          "customerBranchNumber",
          "orderStatus",
          "approvalDate",
        ],
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
    const customerOrderResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.findOrder

    if (!customerOrderResponse || customerOrderResponse.length <= 0) {
      throw new Error("No response available")
    }

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customerOrderResponse.customerNumber,
    })

    return customerOrderResponse
  },
}
